export const tncConfig = [
  {
    "title": "Terms of Use",
    "content": [
      {
        "que": 'Introduction',
        "ans": [
          { value: 'These terms and conditions shall govern your use of our website.' },
          {
            value: 'By agreeing to use our website, you agree to accept these terms and conditions in full;'
          },

          { value: 'If you register with our website, submit any material to our website or use any of our website services, we will ask you to expressly agree to these terms and conditions.' },
          { value: 'You must be at least [18] years of age to use our website; and by using our website or agreeing to these terms and conditions, you warrant and represent to us that you are at least [18] years of age.' },
          { value: 'Our website uses cookies; by using our website or agreeing to these terms and conditions, you consent to our use of cookies in accordance with the terms of our [privacy and cookies policy].' }

        ]
      },
      {
        que: 'Copyright notice',
        ans: [
          { value: 'Copyright (c) 2019 TRACTOR BAZAR.', },
          {
            header: 'Subject to the express provisions of these terms and conditions:',
            type: 'subPointer',
            points: [
              'we, together with our licensors, own and control all the copyright and other intellectual property rights in our website and the material on our website, and are reserved.'
            ]
          }

        ]
      },
      {
        que: 'Licence to use website',
        ans: [
          {
            type: 'subPointer',
            header: 'You may:',
            points: [
              'View pages from our website in a web browser;',
              'Download pages from our website for caching in a web browser;',
              'Print pages from our website;',
              'Stream audio and video files from our website; and',
              'Use [our website services] by means of a web browser,'
            ]
          },
          { value: 'Except as expressly permitted by Section 4.1 or the other provisions of these terms and conditions, you must not download any material from our website or save any such material to your computer / phone.' },
          { value: 'You may use our website only for your business purpose.' },
          { value: 'Except as expressly permitted by these terms and conditions, you must not edit or otherwise modify any material on our website.' },
          {
            type: 'subPointer',
            header: 'Unless you own or control the relevant rights in the material, you must not:',
            points: [
              'Republish material from our website (including republication on another website);',
              'Sell, rent or sub-license material from our website;',
              'Show any material from our website in public;',
              'Exploit material from our website for a commercial purpose; or',
              'Redistribute material from our website.',
              'We reserve the right to restrict access to areas of our website, or indeed our whole website, at our discretion; you must not circumvent or bypass, or attempt to circumvent or bypass, any access restriction measures on our website.'
            ]
          }
        ]
      },
      {
        que: 'Acceptable use',
        ans: [
          {

            type: 'subPointer',
            header: 'You must not:',
            points: [
              'use our website in any way or take any action that causes, or may cause, damage to the website or impairment of the performance, availability or accessibility of the website;',
              'use our website in any way or take any action that is unlawful, illegal, fraudulent or harmful, or in connection with any unlawful, illegal, fraudulent or harmful purpose or activity;',
              'use our website to copy, store, host, transmit, send, use, publish or distribute any material which consists of (or is linked to) any spyware, computer virus, Trojan horse, worm, keystroke logger, rootkit or other malicious computer software;',
              'Conduct any systematic or automated data collection activities (including without limitation scraping, data mining, data extraction and data harvesting) on or in relation to our website without our express written consent;',
              'Access or otherwise interact with our website using any robot, spider or other automated means;',
              'Violate the directives set out in the robots.txt file for our website; or',
              'Use data collected from our website for any direct marketing activity (including without limitation email marketing, SMS marketing, telemarketing and direct mailing).'
            ]
          },
          {
            value: 'You must not use data collected from our website to contact individuals, companies or other persons or entities.'
          },
          { value: 'You must ensure that all the information you supply to us through our website, or in relation to our website, is [true, accurate, current, complete and non-misleading].' }
        ]
      },
      {
        que: 'Registration and accounts',
        ans: [
          { value: 'To be eligible for an individual account on our website under this, you must be at least 18 years of age.' },
          { value: 'You may register for an account with our website by completing and submitting the account registration form on our website, and clicking on the verification link in the email that the website will send to you.' },
          { value: 'You must notify us in writing immediately if you become aware of any unauthorised use of your account.' },
          { value: 'You must not use any other person\'s account to access the website. ' },
        ]
      },
      {
        que: 'User IDs and passwords',
        ans: [
          {
            value: 'If you register for an account with our website, we will provide you with / you will be asked to choose a user ID and password.'
          },
          {
            value: 'Your user ID must not be liable to mislead and must comply with the content rules set out in Section 10; you must not use your account or user ID for or in connection with the impersonation of any person.'
          },
          {
            value: 'You must keep your password confidential.',
          },
          {
            value: 'You must notify us in writing immediately if you become aware of any disclosure of your password.'
          },
          {
            value: 'You are responsible for any activity on our website arising out of any failure to keep your password confidential, and may be held liable for any losses arising out of such a failure.'
          }
        ]
      },
      {
        que: 'Cancellation and suspension of account',
        ans: [
          {
            type: 'subPointer',
            header: 'We may:',
            points: [
              'Suspend your account;',
              'Cancel your account; and/or',
              'Edit your account details, At any time in our sole discretion without notice or explanation.'
            ]
          },
          {
            value: 'You may edit your account on our website.'
          }
        ]
      },
      {
        que: 'Your content: licence',
        ans: [
          { value: 'In these terms and conditions, "your content" means all works and materials (including without limitation text, graphics, images, audio material, video material, audio-visual material, scripts, software and files) that you submit to us or our website for storage or publication on, processing by, or transmission via, our website.' },
          { value: 'You grant to us an irrevocable, non-exclusive, royalty-free licence to use, reproduce, store, publish, translate and distribute your content in  relation to this website with your consent, which consent is deemed to have been granted when you accept these terms.' },
          { value: 'You grant to us the right to bring an action for infringement of the rights licensed.' },
          { value: 'You may edit your content to the extent permitted using the editing functionality made available on our website.' },
          { value: 'Without prejudice to our other rights under these terms and conditions, if you breach any provision of these terms and conditions in any way, or if we reasonably suspect that you have breached these terms and conditions in any way, we may delete, unpublish or edit any or all of your content.' },
        ]
      },
      {
        que: 'Your content: rules',
        ans: [
          { value: 'You warrant and represent that your content will comply with these terms and conditions.' },
          { value: 'Your content must not be illegal or unlawful, must not infringe any person\'s legal rights, and must not be capable of giving rise to legal action against any person (in each case in any jurisdiction and under any applicable law).' },
          {
            header: 'Your content, and the use of your content by us in accordance with these terms and conditions, must not:',
            type: 'subPointer',
            points: [
              'Be libellous or maliciously false, obscene or indecent or blasphemous;',
              'infringe any copyright, moral right, database right, trade mark right, design right, right in passing off, or other intellectual property right;',
              'Infringe any right of confidence, right of privacy or right under data protection legislation;',
              'Constitute negligent advice or contain any negligent statement;',
              'promotion of criminal activity;',
              'Be in contempt of any court, or in breach of any court order;',
              'Be in breach of racial or religious hatred or discrimination legislation or depict violence;',
              'Be in breach of official secrets legislation;',
              'Be in breach of any contractual obligation owed to any person;',
              'Be untrue, false, inaccurate or misleading',
              'consist of or contain any instructions, advice or other information which may be acted upon and could, if acted upon, cause illness, injury or death, or any other loss or damage;',
              'Constitute spam;',
            ]
          }
        ]
      },
      {
        que: 'Limited warranties',
        ans: [
          {
            type: 'subPointer',
            header: 'We do not warrant or represent:',
            points: [
              'The completeness or accuracy of the information published on our website;',
              'That the material on the website is up to date; or',
              'That the website or any service on the website will remain available.'
            ]
          },
          { value: 'We reserve the right to discontinue or alter any or all of our website services, and to stop publishing our website, at any time in our sole discretion without notice or explanation; and save to the extent expressly provided otherwise in these terms and conditions, you will not be entitled to any compensation or other payment upon the discontinuance or alteration of any website services, or if we stop publishing the website.' },
          { value: 'To the maximum extent permitted by applicable law and subject to Section 12.1, we exclude all representations and warranties relating to the subject matter of these terms and conditions, our website and the use of our website.' }
        ]
      },
      {
        que: 'Limitations and exclusions of liability',
        ans: [
          {
            type: 'subPointer',
            header: 'Nothing in these terms and conditions will:',
            points: [
              'Limit or exclude any liability for death or personal injury resulting from negligence;',
              'Limit or exclude any liability for fraud or fraudulent misrepresentation;',
              'Limit any liabilities in any way that is not permitted under applicable law; or',
              'Exclude any liabilities that may not be excluded under applicable law.'
            ]
          },
          {
            type: 'subPointer',
            header: 'The limitations and exclusions of liability set out in this Section 12 and elsewhere in these terms and conditions:',
            points: [
              'Govern all liabilities arising under these terms and conditions or relating to the subject matter of these terms and conditions, including liabilities arising in contract, in tort (including negligence) and for breach of statutory duty.'
            ]
          },
          { value: 'To the extent that our website and the information and services on our website are provided free of charge, we will not be liable for any loss or damage of any nature.' },
          { value: 'We will not be liable to you in respect of any losses arising out of any event or events beyond our reasonable control.' },
          { value: 'We will not be liable to you in respect of any business losses, including (without limitation) loss of or damage to profits, income, revenue, use, production, anticipated savings, business, contracts, commercial opportunities or goodwill.' },
          { value: 'We will not be liable to you in respect of any loss or corruption of any data, database or software.' },
          { value: 'We will not be liable to you in respect of any special, indirect or consequential loss or damage.' },
          { value: 'You accept that we have an interest in limiting the liability of our officers and employees and, having regard to that interest, you acknowledge and agree that you will not bring any claim personally against our officers or employees in respect of any losses you suffer in connection with the website or these terms and conditions.' }
        ]
      },
      {
        que: 'Breaches of these terms and conditions',
        ans: [
          {
            type: 'subPointer',
            header: 'Without prejudice to our other rights under these terms and conditions, if you breach these terms and conditions in any way, or if we reasonably suspect that you have breached these terms and conditions in any way, we may:',
            points: [
              'Send you one or more formal warnings;',
              'Temporarily suspend your access to our website;',
              'Permanently prohibit you from accessing our website;',
              'Block computers using your IP address from accessing our website;',
              'Contact any or all your internet service providers and request that they block your access to our website;',
              'Commence legal action against you, whether for breach of contract or otherwise; and/or',
              'Suspend or delete your account on our website.'
            ]
          },
          {
            value: 'Where we suspend or prohibit or block your access to our website or a part of our website, you must not take any action to circumvent such suspension or prohibition or blocking (including without limitation creating and/or using a different account).'
          }
        ]
      },
      {
        que: 'Variation',
        ans: [
          { value: 'We may revise these terms and conditions from time to time.' },
          {
            value: 'The revised terms and conditions shall apply to the use of our website from the date of publication of the revised terms and conditions on the website, and you hereby waive any right you may otherwise have to be notified of, or to consent to, revisions of these terms and conditions.'
          }]
      },
      {
        que: 'Assignment',
        ans: [
          { value: 'You hereby agree that we may assign, transfer, sub-contract or otherwise deal with our rights and/or obligations under these terms and conditions.' },
          { value: 'You may not without our prior written consent assign, transfer, sub-contract or otherwise deal with any of your rights and/or obligations under these terms and conditions.' }
        ]
      },
      {
        que: 'Severability',
        ans: [
          { value: 'If a provision of these terms and conditions is determined by any court or other competent authority to be unlawful and/or unenforceable, the other provisions will continue in effect.' },
          { value: 'If any unlawful and/or unenforceable provision of these terms and conditions would be lawful or enforceable if part of it were deleted, that part will be deemed to be deleted, and the rest of the provision will continue in effect.' }
        ]
      },
      {
        que: 'Third party rights',
        ans: [
          { value: 'These terms and conditions are for our benefit and your benefit, and these terms and conditions are not intended to benefit or be enforceable by any third party.' },
          { value: 'The exercise of the parties\' rights under these terms and conditions is not subject to the consent of any third party.' }
        ]
      },
      {
        que: 'Entire agreement',
        ans: [
          { value: 'These terms and conditions, together with our privacy and cookies policy, shall constitute the entire agreement between you and us in relation to your use of our website and shall supersede all previous agreements between you and us in relation to your use of our website.' }
        ]
      }]
  },
  {
    "title": "Privacy Policy",
    "content": [
      {
        "que": 'Introduction',
        "ans": [
          { value: 'We are committed to safeguarding the privacy of our website visitors; in this policy we explain how we will treat your personal information.' },
          {
            value: 'We will ask you to consent to our use of cookies in accordance with the terms of this policy when you first visit our website. / By using our website and agreeing to this policy, you consent to our use of cookies in accordance with the terms of this policy.'
          }
        ]
      },
      {
        que: 'Collecting personal information',
        "ans": [

          {
            type: 'subPointer',
            header: 'We may collect, store and use the following kinds of personal information:',
            points: [
              'Information about your computer and about your visits to and use of this website (including your IP address, geographical location, browser type and version, operating system, referral source, length of visit, page views and website navigation paths);',
              'Information that you provide to us when registering with our website (including [your email address])',
              'Information that you provide when completing your profile on our website (including [your basic profile information);',
              'Information that you provide to us when using the services on our website, or that is generated in the course of the use of those services (including [the timing, frequency and pattern of service use]',
              'Information that you post to our website for publication on the internet (including [your user name, your profile and the content of your posts])',
              'Information contained in or relating to any communications that you send to us or send through our website (including [the communication content and Meta data associated with the communication])',
              'Any other personal information that you choose to send to us'
            ]
          },

          {
            value: 'Before you disclose to us the personal information of another person, you must obtain that person\'s consent to both the disclosure and the processing of that personal information in accordance with this policy.'
          }
        ]
      },
      {
        que: 'Using your personal information',
        "ans": [
          { value: 'Personal information submitted to us through our website will be used for the purposes specified in this policy or on the relevant pages of the website.' },
          {
            type: 'subPointer',
            header: 'We may use your personal information to:',
            points: [
              'Administer our website and business',
              'Personalise our website for you',
              'Enable your use of the services available on our website',
              'Send you non-marketing commercial communications',
              'Send you email/SMS notifications that you have specifically requested',
              'Send you marketing communications relating to our business which we think may be of interest to you, by post or, where you have specifically agreed to this, by email or similar technology (you can inform us at any time if you no longer require marketing communications)',
              'Provide third parties with statistical information about our users (but those third parties will not be able to identify any individual user from that information)',
              'Deal with enquiries and complaints made by or about you relating to our website',
              'Keep our website secure and prevent fraud',
              'Verify compliance with the terms and conditions governing the use of our website (including monitoring messages sent through our website messaging service)',
            ]
          },
          { value: 'If you submit personal information for publication on our website, we will publish and otherwise use that information in accordance with the licence you grant to us.' },
          { value: 'Your privacy settings can be used to limit the publication of your information on our website, and can be adjusted using privacy controls on the website.' },
          {
            value: 'We will not, without your express consent, supply your personal information to any third party for the purpose of their or any other third party\'s direct marketing.'
          }

        ]
      },
      {
        que: 'Disclosing personal information',
        ans: [
          { value: 'We may disclose your personal information to any of our employees, officers, professional advisers and agents insofar as reasonably necessary for the purposes set out in this policy.' },
          { value: 'We may disclose your personal information to any member of our group of companies (this means our subsidiaries, our ultimate holding company and all its subsidiaries) insofar as reasonably necessary for the purposes set out in this policy' },
          {
            type: 'subPointer',
            header: 'may disclose your personal information:',
            points: [
              'the extent that we are required to do so by law;',
              'In connection with any ongoing or prospective legal proceedings;',
              'In order to establish, exercise or defend our legal rights (including providing information to others for the purposes of fraud prevention and reducing credit risk);',
              'To any person who we reasonably believe may apply to a court or other competent authority for disclosure of that personal information where, in our reasonable opinion, such court or authority would be reasonably likely to order disclosure of that personal information.'
            ]
          },
          { value: 'Except as provided in this policy, we will not provide your personal information to third parties.' }
        ]
      },
      {
        que: 'Retaining personal information',
        ans: [
          { value: 'This section sets out our data retention policies and procedure, which are designed to help ensure that we comply with our legal obligations in relation to the retention and deletion of personal information.' },
          { value: 'Personal information that we process for any purpose or purposes shall not be kept for longer than is necessary for that purpose or those purposes.' },
          { value: 'Unless required as stated above, we will usually delete personal data at the date/time set out by the company' },
          {
            type: 'subPointer',
            header: 'Notwithstanding the other provisions of this Section, we will retain documents (including electronic documents) containing personal data:',
            points: [
              'To the extent that we are required to do so by law;',
              'If we believe that the documents may be relevant to any ongoing or prospective legal proceedings; and',
              'In order to establish, exercise or defend our legal rights (including providing information to others for the purposes of fraud prevention and reducing credit risk).'
            ]
          }]
      },
      {
        que: 'Security of your personal information',
        ans: [
          { value: 'We will take reasonable technical and organisational precautions to prevent the loss, misuse or alteration of your personal information.' },
          { value: 'We will store all the personal information you provide on our secure (password- and firewall-protected) servers.' },
          { value: 'You acknowledge that the transmission of information over the internet is inherently insecure, and we cannot guarantee the security of data sent over the internet.' },
          { value: 'You are responsible for keeping the password you use for accessing our website confidential; we will not ask you for your password (except when you log in to our website).' }
        ]
      },

      {
        que: 'Security of your personal information',
        ans: [
          { value: 'We will take reasonable technical and organisational precautions to prevent the loss, misuse or alteration of your personal information.' },
          { value: 'We will store all the personal information you provide on our secure (password- and firewall-protected) servers.' },
          { value: 'You acknowledge that the transmission of information over the internet is inherently insecure, and we cannot guarantee the security of data sent over the internet.' },
          { value: 'You are responsible for keeping the password you use for accessing our website confidential; we will not ask you for your password (except when you log in to our website).' }
        ]
      },

      {
        que: 'Amendments',
        ans: [
          { value: 'We may update this policy from time to time by publishing a new version on our website.' },
          { value: 'You should check this page occasionally to ensure you are happy with any changes to this policy.' },
          { value: 'We may notify you of changes to this policy by email or through the private messaging system on our website.' }
        ]
      },
      {
        que: 'Your rights',
        ans: [
          {
            type: 'subPointer',
            header: 'You may instruct us to provide you with any personal information we hold about you; provision of such information will be subject to:',
            points: [
              'The supply of appropriate evidence of your identity [(for this purpose, we will usually accept a photocopy of your authorized proof of identity by a solicitor or bank plus an original copy of a utility bill showing your current address)].'
            ]
          },
          { value: 'We may withhold personal information that you request to the extent permitted by law.' },
          { value: 'You may instruct us at any time not to process your personal information for marketing purposes.' },
          { value: 'In practice, you will usually either expressly agree in advance to our use of your personal information for marketing purposes, or we will provide you with an opportunity to opt out of the use of your personal information for marketing purposes.' }
        ]
      },
      {
        que: 'Third party websites when provided by us',
        ans: [
          { value: 'Our website may include hyperlinks to, and details of, third party websites.' },
          { value: 'We have no control over, and are not responsible for, the privacy policies and practices of third parties.' }
        ]
      },
      {
        que: 'Updating Information',
        ans: [
          { value: 'Please let us know if the personal information that we hold about you needs to be corrected or updated.' }
        ]
      },

      {
        que: 'Cookies',
        ans: [
          { value: 'Our website uses cookies.' },
          { value: 'A cookie is a file containing an identifier (a string of letters and numbers) that is sent by a web server to a web browser and is stored by the browser. The identifier is then sent back to the server each time the browser requests a page from the server.' },
          { value: 'Cookies may be either "persistent" cookies or "session" cookies: a persistent cookie will be stored by a web browser and will remain valid until its set expiry date, unless deleted by the user before the expiry date; a session cookie, on the other hand, will expire at the end of the user session, when the web browser is closed.' },
          { value: 'Cookies do not typically contain any information that personally identifies a user, but personal information that we store about you may be linked to the information stored in and obtained from cookies.' },
          { value: 'We use only session cookies / only persistent cookies / both session and persistent cookies on our website.' },

          {
            type: 'subPointer',
            header: 'The names of the cookies that we use on our website, and the purposes for which they are used, are set out below:',
            points: [
              'we use [cookie name] on our website to recognise a computer when a user visits the website / track users as they navigate the website / enable the use of a shopping cart on the website / improve the website\'s usability / analyse the use of the website / administer the website / prevent fraud and improve the security of the website / personalise the website for each user / target advertisements which may be of particular interest to specific users / describe purpose(s);'
            ]
          },
          {
            type: 'subPointer',
            header: 'Most browsers allow you to refuse to accept cookies; for example:',
            points: [
              'in Internet Explorer (version 10) you can block cookies using the cookie handling override settings available by clicking "Tools", "Internet Options", "Privacy" and then "Advanced";',
              'in Firefox (version 24) you can block all cookies by clicking "Tools", "Options", "Privacy", selecting "Use custom settings for history" from the drop-down menu, and unticking "Accept cookies from sites"; and',
              'in Chrome (version 29), you can block all cookies by accessing the "Customise and control" menu, and clicking "Settings", "Show advanced settings" and "Content settings", and then selecting "Block sites from setting any data" under the "Cookies" heading.',
            ]
          },
          { value: 'Blocking all cookies will have a negative impact upon the usability of many websites.' },
          {
            value: 'If you block cookies, you will not be able to use all the features on our website.'
          },
          {
            type: 'subPointer',
            header: 'You can delete cookies already stored on your computer; for example:',
            points: [
              'in Internet Explorer (version 10), you must manually delete cookie files (you can find instructions for doing so at http://support.microsoft.com/kb/278835);',
              'in Firefox (version 24), you can delete cookies by clicking "Tools", "Options" and "Privacy", then selecting "Use custom settings for history", clicking "Show Cookies", and then clicking "Remove All Cookies"; and',
              'in Chrome (version 29), you can delete all cookies by accessing the "Customise and control" menu, and clicking "Settings", "Show advanced settings" and "Clear browsing data", and then selecting "Delete cookies and other site and plug-in data" before clicking "Clear browsing data”',
            ]
          },
          {
            value: 'Deleting cookies will have a negative impact on the usability of many websites.'
          }

        ]
      }
    ]

  }
];


export const tncDisclaimerLegalNote = [
  {
    "title": "Disclaimer",
    values: [
      'TRACTOR BAZAR assumes no responsibility whatsoever for any consequence relating directly or indirectly to any action you take, or fail to make, based on the content, information, services or other materials found in this system. TRACTOR BAZAR does not guarantee, and will not be responsible for any damage and/or loss related to the accuracy, completeness and/or timeliness of the contents found in the system. It is only a facilitator platform for the owner of the tractor/ Dealer and the Buyer. It is the duty of the Buyer to do their due diligence on the information shared on this platform and then buy the tractor. ',
      'TRACTOR BAZAR not responsible for any buying and selling of tractor and also we are not liable for any claims on the exchange tractor. TRACTOR BAZAR does not have any financial bearing on any of the transaction, the tractor being exchanged as the sole property of the owner of the tractor.',
      'TRACTOR BAZAR may and can include links to external systems in which TRACTOR BAZAR has no responsibility of any kind on these systems. The use and/or access of these external systems are completely and solely at your own risk.',
      'TRACTOR BAZAR DISCLAIMS ALL EXPRESS AND IMPLIED WARRANTIES WITH REGARD TO THE CONTENT, INFORMATION, SERVICES, AND MATERIALS CONTAINED ON THIS SYSTEM; INCLUDING WITHOUT LIMITATION ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. ALL SUCH INFORMATION, SERVICES, AND MATERIALS ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT ANY WARRANTY OF ANY KIND.',
      'IN NO EVENT SHALL TRACTOR BAZAR BE LIABLE FOR ANY SPECIAL, INDIRECT, PUNITIVE, INCIDENTAL, EXEMPLARY OR CONSEQUENTIAL DAMAGES, OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, BUSINESS, DATA OR PROFITS, LITIGATION AND THE LIKE, WHETHER BASED ON BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE), PRODUCT LIABILITY OR OTHERWISE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THE MEMBER AND/OR USER ACKNOWLEDGES AND AGREES THAT THE LIMITATIONS SET FORTH ABOVE ARE FUNDAMENTAL ELEMENTS OF THIS AGREEMENT AND THE SYSTEM WOULD NOT BE PROVIDED TO YOU IN THE ABSENCE OF SUCH LIMITATIONS.'
    ]
  },
  {
    "title": "Legal Note",
    values: [
      'DEALER should get NO OBJECTION/NO LIABLE certificate sign off from Farmer/Owner or whoever bring the tractor for exchange through the TRACTOR BAZAR.',
      'Neither the Company nor the DEALER shall not be liable for any damage or loss of tractor which has been enrolled in TRACTOR BAZAR',
      'DEALER should get NO OBJECTION/NO LIABLE certificate sign off from Buyer, whoever buys the tractor.',
      'Neither the Company, nor the DEALER is not liable for any damage of tractor which is sold.',
      'TRACTOR BAZAR has no control over any element of such information available in Site; the Buyer shall use the Service and the Website at their own risk.'
    ]
  }

];
